import * as React from "react";
import { forwardRef } from "react";
const SvgOpenMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-menu", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 4, x2: 20, y1: 12, y2: 12 }), /* @__PURE__ */ React.createElement("line", { x1: 4, x2: 20, y1: 6, y2: 6 }), /* @__PURE__ */ React.createElement("line", { x1: 4, x2: 20, y1: 18, y2: 18 }));
const ForwardRef = forwardRef(SvgOpenMenu);
export { ForwardRef as ReactComponent };
